import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rangeMinMax',
  standalone: true,
})
export class RangeMinMaxPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || !value.includes(',')) return value;
    const nums = value.split(',').map(Number).filter(n => !isNaN(n));
    return nums.length === 2 ? `${nums[0]} a ${nums[1]}` : nums.join(' - ');
  }
}
